import { metricOf, hasValue } from '../../performance-operations/config';
import { PROCESS_RULES, statusTarget } from '../../../components/performance/processHealthLinks';

// PM Analitik Faz 2 Plan 4 (spec §7) — E02 Süreç Takibi veri katmanı. Sayfa yalnız mevcut uçları okur (İK Operasyon Panosu'nun
// fetch/usePanel yardımcıları paylaşılır):
//   GET v1/performance-analytics/metrics?codes=SUMMARY_CODES        (KPI'lar; M03 aşama kırılımından)
//   GET v1/performance-analytics/breakdown?codes=…&dimension=stage|department|assignee
//   GET v1/performance-analytics/tasks?…&mandatory=true             (Görevler sekmesi — config/tasks.js)
//   GET v1/performance-insights?ruleCode[in]=PROCESS_RULES           (AI alanı)

export const SUMMARY_CODES = ['M01', 'M02', 'M04', 'M05', 'M48', 'M49', 'M50'];
export const MATRIX_CODES = ['M03', 'pm.tasksDone', 'pm.tasksInProgress', 'M04', 'pm.tasksExempt', 'pm.tasksNotOpened'];
export const UNIT_CODES = ['pm.tasksDone', 'pm.tasksInProgress', 'M04', 'pm.tasksExempt'];
export { PROCESS_RULES };
export const TOP_UNITS = 10;
export const TOP_ASSIGNEES = 10;
export const AI_CARDS = 3;
// "Tüm Birimler" çok birimli kiracıda tek SVG'de yüzlerce çubuk çizmez: bu sayının üstünde genişletilmiş görünüm tablodur.
export const UNIT_CHART_MAX = 30;

// Aşama × durum matrisinin sütunları: metrik kodu ve hücre tıklamasının Görevler hedefi (spec §7.2; sayı = liste, §19/4).
export const MATRIX_COLUMNS = [
  { key: 'people', code: 'M03' },
  { key: 'done', code: 'pm.tasksDone' },
  { key: 'waiting', code: 'pm.tasksInProgress' },
  { key: 'overdue', code: 'M04' },
  { key: 'exempt', code: 'pm.tasksExempt' },
  { key: 'notOpened', code: 'pm.tasksNotOpened' },
];

// Matris sütunu → durum dilimi (Bekliyor = pm.tasksInProgress); "people" (kişi tamamlama) yalnız aşamayla açar.
const COLUMN_SEGMENT = { done: 'done', waiting: 'inProgress', overdue: 'overdue', exempt: 'exempt', notOpened: 'notOpened' };

export function matrixTarget(stageKey, column) {
  return { stage: stageKey, ...statusTarget(COLUMN_SEGMENT[column]) };
}

// Birim çubuğunun dilimleri (Tamamlandı / Bekliyor / Gecikti / Muaf) ve dilim tıklamasının Görevler hedefi.
export const UNIT_SEGMENTS = [
  { key: 'done', code: 'pm.tasksDone', task: statusTarget('done') },
  { key: 'waiting', code: 'pm.tasksInProgress', task: statusTarget('inProgress') },
  { key: 'overdue', code: 'M04', task: statusTarget('overdue') },
  { key: 'exempt', code: 'pm.tasksExempt', task: statusTarget('exempt') },
];

// M03 kartının varsayılan aşaması (spec §7.2): katalog sırasında (sunucu hücreleri bu sırayla döner) %100 olmayan ilk aşama;
// hepsi tamamsa ya da hiçbirinde veri yoksa ilk aşama.
export function defaultM03Stage(cells) {
  const stages = (cells || []).filter((c) => c.key);
  if (stages.length === 0) return null;
  const open = stages.find((c) => {
    const m = metricOf(c.metrics, 'M03');
    return hasValue(m) && Number(m.value) < 100;
  });
  return (open || stages[0]).key;
}

const num = (m) => (m && m.value != null ? Number(m.value) : 0);

// Birim satırları: geciken görev sayısına göre azalan, eşitlikte ad; genişletilmemişse ilk n (iç kaydırma yok, kart büyür).
export function unitRows(cells, n = TOP_UNITS, expanded = false) {
  const rows = [...(cells || [])]
    .filter((c) => c.key)
    .map((c) => ({ cell: c, segments: UNIT_SEGMENTS.map((s) => ({ ...s, value: num(metricOf(c.metrics, s.code)) })) }))
    .sort((a, b) => num(metricOf(b.cell.metrics, 'M04')) - num(metricOf(a.cell.metrics, 'M04'))
      || String(a.cell.label || '').localeCompare(String(b.cell.label || '')));
  return expanded ? rows : rows.slice(0, n);
}

// Geciken Sorumlular: sunucu sırası (M04 azalan, "Diğer" sonda); çalışan olmayan anahtarların görünen adı.
export const ASSIGNEE_SPECIAL_KEYS = ['hr_pool', 'external', 'unassigned', 'other'];
export const isEmployeeAssignee = (key) => !!key && !ASSIGNEE_SPECIAL_KEYS.includes(key);
